import { useEffect, useRef } from "react";

const BOTTOM_THRESHOLD_PX = 150;

/**
 * Provides `containerRef` / `messagesEndRef` and auto-scrolls `messagesEndRef` into
 * view whenever `deps` change, but only if the user is already near the bottom of
 * `containerRef`. Prevents jarring jumps when links or images are rendered mid-stream.
 */
export const useAutoScrollToBottom = (deps: unknown[]) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const distanceFromBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
    if (distanceFromBottom < BOTTOM_THRESHOLD_PX) {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { containerRef, messagesEndRef };
};
